import React, { useRef, useEffect } from 'react';
import './BakeryHero.css';

const BakeryHero = () => {
  const videoRef = useRef(null);

  // Lazy-load autoplay with IntersectionObserver
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && videoRef.current && videoRef.current.paused) {
          videoRef.current.play().catch(() => {}); // ignore autoplay errors
        }
      },
      { threshold: 0.5 }
    );
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);

  const togglePlayback = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {}); // ignore autoplay restrictions
    } else {
      video.pause();
    }
  };
  //https://res.cloudinary.com/dqqoti4er/video/upload/v1745950049/pablitostacos_1744041936_3605607345249761597_9383903430_hedr4l.mov
  return (
    <div className="hero-container">
      <video
        ref={videoRef}
        muted
        loop
        playsInline
        preload="none"
        className="hero-video"
        onClick={togglePlayback}
      >
        <source
          src="https://res.cloudinary.com/dqqoti4er/video/upload/v1745950049/pablitostacos_1744041936_3605607345249761597_9383903430_hedr4l.mov"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div className="hero-text">
        <h1>Peruvian Rotisserie Chicken</h1>
        <p>Sandwiches · Lomo Saltado · Ceviche · Salad</p>
      </div>

      <button
        className="hero-toggle-button"
        onClick={togglePlayback}
        aria-label="Toggle video"
      >
        ❚❚
      </button>
    </div>
  );
};

export default BakeryHero;